export default __webpack_public_path__ + "static/media/profile-user.9b8871af.png";